const getters = {
  documento: (state) => state.documento,
  presenteCaixaPostal: (state) => state.presenteCaixaPostal,
  raizPresenteCaixaPostal: (state) => state.raizPresenteCaixaPostal,
  emailInteressado: (state) => state.emailInteressado,
  consolidacaoURL: (state) => state.consolidacaoURL,
  listaConsolidacoes: (state) => state.listaConsolidacoes
}

export default getters
